const React = require('react');
const noop = require('mn-utils/noop');
const {AdminFormRow, AdminFormCol} = require('../../../../../AdminLayout');
const {FormFooter, FormWrapper} = require('../../../../../../FormHandlers');
const {AdminSelect, AdminInput} = require('../../../../../../FormInputs');
const {COUNTRIES} = require('../../../../../../../../constants/countries');

const MAPPED_TO_ITEMS = require('./constants/mappedTo');
const walletFormSchema = require('./utils/walletFormSchema').default;

module.exports = ({data = {}, onSubmit = noop, onResult = noop}) => (
  <FormWrapper
    data={data}
    schema={walletFormSchema}
    onSubmit={onSubmit}
    onResult={onResult}
  >{(formCtx) => {
      const cryptoSelected = !!formCtx.state.data['coin'];
      return (
        <>
          <AdminFormRow className="mt22">
            <AdminFormCol>
              <AdminSelect
                name="coin"
                label="Select Cryptocurrency"
                propName="0"
                propValue="1"
                items={COUNTRIES}
                formCtx={formCtx}
              />
            </AdminFormCol>
            <AdminFormCol>
              <AdminSelect
                name="network"
                label="Select Network"
                propName="0"
                propValue="1"
                items={COUNTRIES}
                formCtx={formCtx}
                disabled={!cryptoSelected}
              />
            </AdminFormCol>
            <AdminFormCol>
              <AdminInput
                name="address"
                formCtx={formCtx}
              />
            </AdminFormCol>
            <AdminFormCol>
              <AdminSelect
                name="mapped_to"
                propValue="id"
                items={MAPPED_TO_ITEMS}
                formCtx={formCtx}
              />
            </AdminFormCol>
          </AdminFormRow>
          <FormFooter
            submitBtnData={{
              text: 'Save account',
              formCtx,
            }}
          />
        </>
      );
    }}</FormWrapper>
);
